import React from 'react';
import { Flex } from 'rebass';
import { CONTAINER_WIDTH } from "../../utils/constants";
import theme from "../../gatsby-plugin-theme-ui";

const Container = ({ children, sx = {}, containerProps,...props }) => {
	return (
		<Flex
			sx={{
				position: [null, null, 'absolute'],
				width: [null, null, '100%'],
				height: [null, null, '100%'],
				left: 0,
				top: 0,
			}}
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			{...containerProps}
		>
			<Flex
				alignItems="center"
				justifyContent="center"
				width="100%"
				maxWidth={[null, null, CONTAINER_WIDTH,  CONTAINER_WIDTH + 2 * theme.space[5]]}
				px={[20, 40, 5]}
				pt={[45, 60, 0]}
				pb={[60, 70, 0]}
				{...props}
				sx={{
					...sx,
				}}
			>
				{children}
			</Flex>
		</Flex>
	)
};

export default Container;
